export class SubmitApplication {}
